// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Page wrapper ── */
.er-page {
  display: flex;
  justify-content: center;
  padding: 24px 16px 64px;
  min-height: 100%;
}

.er-container {
  width: 100%;
  max-width: 720px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ── Hero ── */
.er-hero {
  border-radius: 20px;
  padding: 36px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
}

.er-hero-pass {
  background: linear-gradient(145deg, rgba(59, 179, 174, 0.12), rgba(7, 20, 20, 0.6));
  border: 1px solid rgba(59, 179, 174, 0.25);
}

.er-hero-fail {
  background: linear-gradient(145deg, rgba(239, 83, 80, 0.1), rgba(180, 40, 40, 0.06));
  border: 1px solid rgba(239, 83, 80, 0.2);
}

.er-hero-icon-wrap {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.er-hero-icon {
  font-size: 48px !important;
}

.er-pass-icon {
  color: #48D1CC !important;
}

.er-fail-icon {
  color: #ef5350 !important;
}

.er-hero-title {
  margin: 0;
  font-size: 26px;
  font-weight: 700;
  color: #ffffff;
}

.er-hero-sub {
  margin: 0;
  font-size: 14px;
  color: #9aa3ad;
  max-width: 420px;
  line-height: 1.6;
}

/* ── Score card ── */
.er-score-card {
  background: #0e1b1b;
  border-radius: 18px;
  border: 1px solid #484848;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.er-score-main {
  display: flex;
  align-items: baseline;
  gap: 6px;
}

.er-score-num {
  font-size: 56px;
  font-weight: 800;
  line-height: 1;
}

.er-score-sep {
  font-size: 28px;
  color: #484848;
  font-weight: 300;
}

.er-score-max {
  font-size: 32px;
  color: #9aa3ad;
  font-weight: 600;
}

.er-score-label {
  font-size: 14px;
  color: #9aa3ad;
  font-weight: 500;
}

/* ── Breakdown card ── */
.er-breakdown-card {
  background: #0e1b1b;
  border-radius: 18px;
  border: 1px solid #484848;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  overflow: hidden;
}

.er-breakdown-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
}

/* ── Table ── */
.er-breakdown-table {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.er-table-header {
  display: grid;
  grid-template-columns: 28px 1fr 1fr 1fr 44px;
  gap: 10px;
  padding: 6px 12px;
}

.er-th {
  font-size: 11px;
  font-weight: 700;
  color: #64707d;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.er-table-row {
  display: grid;
  grid-template-columns: 28px 1fr 1fr 1fr 44px;
  gap: 10px;
  padding: 12px;
  border-radius: 12px;
  align-items: start;
}

.er-row-correct { background: rgba(59, 179, 174, 0.05); }
.er-row-wrong   { background: rgba(239, 83, 80, 0.05); }

.er-td {
  font-size: 13px;
  color: #c5cdd6;
  line-height: 1.5;
  word-break: break-word;
}

.er-td-q {
  color: #64707d;
  font-weight: 600;
  font-size: 12px;
}

.er-td-status {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 2px;
}

.er-answer-correct { color: #48D1CC; font-weight: 600; }
.er-answer-wrong   { color: #ef5350; }

.er-icon-correct {
  color: #48D1CC !important;
  font-size: 18px !important;
}

.er-icon-wrong {
  color: #ef5350 !important;
  font-size: 18px !important;
}

/* ── Action buttons ── */
.er-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.er-btn-primary {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: 12px;
  border: none;
  background: linear-gradient(135deg, #3BB3AE, #0099a8);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.er-btn-primary:hover { opacity: 0.88; transform: translateY(-1px); }

.er-btn-secondary {
  flex: 1 1;
  padding: 12px 24px;
  border-radius: 12px;
  border: 1px solid #484848;
  background: transparent;
  color: #e6eaef;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s ease;
}
.er-btn-secondary:hover { border-color: rgba(255, 255, 255, 0.3); }

.er-btn-ghost {
  flex: 1 1;
  padding: 12px 24px;
  border-radius: 12px;
  border: none;
  background: transparent;
  color: #9aa3ad;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.15s ease;
}
.er-btn-ghost:hover { color: #48D1CC; }

/* ── Error card ── */
.er-error-card {
  background: #0e1b1b;
  border-radius: 16px;
  border: 1px solid rgba(239, 83, 80, 0.2);
  padding: 40px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  color: #9aa3ad;
  text-align: center;
}

/* ── Skeletons ── */
.er-skeleton {
  border-radius: 16px;
  background: linear-gradient(90deg, #0e1b1b 25%, #132828 50%, #0e1b1b 75%);
  background-size: 200% 100%;
  animation: erSkeleton 1.4s ease infinite;
}

.er-skel-hero  { width: 100%; height: 160px; }
.er-skel-score { width: 100%; height: 120px; }
.er-skel-table { width: 100%; height: 240px; }

@keyframes erSkeleton {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ── Unlocked Community Banner ── */
.er-unlock-banner {
  background: linear-gradient(135deg, rgba(59, 179, 174, 0.15) 0%, rgba(14, 27, 27, 0.95) 100%);
  border: 1px solid rgba(59, 179, 174, 0.4);
  border-radius: 18px;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  gap: 18px;
  box-shadow: 0 8px 32px rgba(59, 179, 174, 0.12);
}

.er-unlock-icon-wrap {
  width: 56px;
  height: 56px;
  min-width: 56px;
  border-radius: 14px;
  background: rgba(59, 179, 174, 0.15);
  border: 1px solid rgba(59, 179, 174, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.er-unlock-body {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.er-unlock-badge {
  font-size: 11px;
  font-weight: 700;
  color: #3BB3AE;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.er-unlock-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
}

.er-unlock-sub {
  margin: 0;
  font-size: 13px;
  color: #a0aec0;
  line-height: 1.45;
}

.er-unlock-btn {
  white-space: nowrap;
  padding: 12px 20px;
  border-radius: 10px;
  border: none;
  background: #3BB3AE;
  color: #0b1515;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
}

.er-unlock-btn:hover {
  background: #4be3cf;
  transform: translateY(-2px);
  box-shadow: 0 4px 14px rgba(59, 179, 174, 0.4);
}

@media (max-width: 640px) {
  .er-unlock-banner {
    flex-direction: column;
    text-align: center;
    align-items: center;
  }
  .er-unlock-btn {
    width: 100%;
  }
}

/* ── Responsive ── */
@media (max-width: 640px) {
  .er-hero-title { font-size: 22px; }
  .er-score-num  { font-size: 44px; }

  /* Stack table to vertical cards on mobile */
  .er-table-header { display: none; }

  .er-table-row {
    grid-template-columns: 1fr;
    gap: 6px;
  }

  .er-td-q      { font-size: 11px; color: #64707d; }
  .er-td-status { justify-content: flex-start; }

  .er-td-question::before { content: 'Q: '; color: #64707d; font-weight: 700; }
  .er-td-your::before     { content: 'Your: '; color: #64707d; font-weight: 700; }
  .er-td-correct::before  { content: 'Correct: '; color: #64707d; font-weight: 700; }

  .er-actions { flex-direction: column; }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Certifications/ExamResult/ExamResult.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mFAAmF;EACnF,0CAA0C;AAC5C;;AAEA;EACE,oFAAoF;EACpF,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kBAAkB,oCAAoC,EAAE;AACxD,kBAAkB,mCAAmC,EAAE;;AAEvD;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,qBAAqB,cAAc,EAAE,gBAAgB,EAAE;AACvD,qBAAqB,cAAc,EAAE;;AAErC;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oDAAoD;AACtD;AACA,wBAAwB,aAAa,EAAE,2BAA2B,EAAE;;AAEpE;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mCAAmC;AACrC;AACA,0BAA0B,sCAAsC,EAAE;;AAElE;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA,sBAAsB,cAAc,EAAE;;AAEtC,qBAAqB;AACrB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,yEAAyE;EACzE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA,iBAAiB,WAAW,EAAE,aAAa,EAAE;AAC7C,iBAAiB,WAAW,EAAE,aAAa,EAAE;AAC7C,iBAAiB,WAAW,EAAE,aAAa,EAAE;;AAE7C;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,oCAAoC;AACpC;EACE,6FAA6F;EAC7F,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,oCAAoC;EACpC,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;AACF;;AAEA,qBAAqB;AACrB;EACE,iBAAiB,eAAe,EAAE;EAClC,iBAAiB,eAAe,EAAE;;EAElC,4CAA4C;EAC5C,mBAAmB,aAAa,EAAE;;EAElC;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA,gBAAgB,eAAe,EAAE,cAAc,EAAE;EACjD,gBAAgB,2BAA2B,EAAE;;EAE7C,0BAA0B,cAAc,EAAE,cAAc,EAAE,gBAAgB,EAAE;EAC5E,0BAA0B,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE;EAC/E,0BAA0B,oBAAoB,EAAE,cAAc,EAAE,gBAAgB,EAAE;;EAElF,cAAc,sBAAsB,EAAE;AACxC","sourcesContent":["/* ── Page wrapper ── */\n.er-page {\n  display: flex;\n  justify-content: center;\n  padding: 24px 16px 64px;\n  min-height: 100%;\n}\n\n.er-container {\n  width: 100%;\n  max-width: 720px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ── Hero ── */\n.er-hero {\n  border-radius: 20px;\n  padding: 36px 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  text-align: center;\n}\n\n.er-hero-pass {\n  background: linear-gradient(145deg, rgba(59, 179, 174, 0.12), rgba(7, 20, 20, 0.6));\n  border: 1px solid rgba(59, 179, 174, 0.25);\n}\n\n.er-hero-fail {\n  background: linear-gradient(145deg, rgba(239, 83, 80, 0.1), rgba(180, 40, 40, 0.06));\n  border: 1px solid rgba(239, 83, 80, 0.2);\n}\n\n.er-hero-icon-wrap {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.er-hero-icon {\n  font-size: 48px !important;\n}\n\n.er-pass-icon {\n  color: #48D1CC !important;\n}\n\n.er-fail-icon {\n  color: #ef5350 !important;\n}\n\n.er-hero-title {\n  margin: 0;\n  font-size: 26px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.er-hero-sub {\n  margin: 0;\n  font-size: 14px;\n  color: #9aa3ad;\n  max-width: 420px;\n  line-height: 1.6;\n}\n\n/* ── Score card ── */\n.er-score-card {\n  background: #0e1b1b;\n  border-radius: 18px;\n  border: 1px solid #484848;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n}\n\n.er-score-main {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n}\n\n.er-score-num {\n  font-size: 56px;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.er-score-sep {\n  font-size: 28px;\n  color: #484848;\n  font-weight: 300;\n}\n\n.er-score-max {\n  font-size: 32px;\n  color: #9aa3ad;\n  font-weight: 600;\n}\n\n.er-score-label {\n  font-size: 14px;\n  color: #9aa3ad;\n  font-weight: 500;\n}\n\n/* ── Breakdown card ── */\n.er-breakdown-card {\n  background: #0e1b1b;\n  border-radius: 18px;\n  border: 1px solid #484848;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  overflow: hidden;\n}\n\n.er-breakdown-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n/* ── Table ── */\n.er-breakdown-table {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.er-table-header {\n  display: grid;\n  grid-template-columns: 28px 1fr 1fr 1fr 44px;\n  gap: 10px;\n  padding: 6px 12px;\n}\n\n.er-th {\n  font-size: 11px;\n  font-weight: 700;\n  color: #64707d;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.er-table-row {\n  display: grid;\n  grid-template-columns: 28px 1fr 1fr 1fr 44px;\n  gap: 10px;\n  padding: 12px;\n  border-radius: 12px;\n  align-items: start;\n}\n\n.er-row-correct { background: rgba(59, 179, 174, 0.05); }\n.er-row-wrong   { background: rgba(239, 83, 80, 0.05); }\n\n.er-td {\n  font-size: 13px;\n  color: #c5cdd6;\n  line-height: 1.5;\n  word-break: break-word;\n}\n\n.er-td-q {\n  color: #64707d;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.er-td-status {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding-top: 2px;\n}\n\n.er-answer-correct { color: #48D1CC; font-weight: 600; }\n.er-answer-wrong   { color: #ef5350; }\n\n.er-icon-correct {\n  color: #48D1CC !important;\n  font-size: 18px !important;\n}\n\n.er-icon-wrong {\n  color: #ef5350 !important;\n  font-size: 18px !important;\n}\n\n/* ── Action buttons ── */\n.er-actions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-top: 8px;\n}\n\n.er-btn-primary {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px 24px;\n  border-radius: 12px;\n  border: none;\n  background: linear-gradient(135deg, #3BB3AE, #0099a8);\n  color: #fff;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: opacity 0.15s ease, transform 0.15s ease;\n}\n.er-btn-primary:hover { opacity: 0.88; transform: translateY(-1px); }\n\n.er-btn-secondary {\n  flex: 1;\n  padding: 12px 24px;\n  border-radius: 12px;\n  border: 1px solid #484848;\n  background: transparent;\n  color: #e6eaef;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: border-color 0.15s ease;\n}\n.er-btn-secondary:hover { border-color: rgba(255, 255, 255, 0.3); }\n\n.er-btn-ghost {\n  flex: 1;\n  padding: 12px 24px;\n  border-radius: 12px;\n  border: none;\n  background: transparent;\n  color: #9aa3ad;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: color 0.15s ease;\n}\n.er-btn-ghost:hover { color: #48D1CC; }\n\n/* ── Error card ── */\n.er-error-card {\n  background: #0e1b1b;\n  border-radius: 16px;\n  border: 1px solid rgba(239, 83, 80, 0.2);\n  padding: 40px 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  color: #9aa3ad;\n  text-align: center;\n}\n\n/* ── Skeletons ── */\n.er-skeleton {\n  border-radius: 16px;\n  background: linear-gradient(90deg, #0e1b1b 25%, #132828 50%, #0e1b1b 75%);\n  background-size: 200% 100%;\n  animation: erSkeleton 1.4s ease infinite;\n}\n\n.er-skel-hero  { width: 100%; height: 160px; }\n.er-skel-score { width: 100%; height: 120px; }\n.er-skel-table { width: 100%; height: 240px; }\n\n@keyframes erSkeleton {\n  0%   { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* ── Unlocked Community Banner ── */\n.er-unlock-banner {\n  background: linear-gradient(135deg, rgba(59, 179, 174, 0.15) 0%, rgba(14, 27, 27, 0.95) 100%);\n  border: 1px solid rgba(59, 179, 174, 0.4);\n  border-radius: 18px;\n  padding: 20px 24px;\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  box-shadow: 0 8px 32px rgba(59, 179, 174, 0.12);\n}\n\n.er-unlock-icon-wrap {\n  width: 56px;\n  height: 56px;\n  min-width: 56px;\n  border-radius: 14px;\n  background: rgba(59, 179, 174, 0.15);\n  border: 1px solid rgba(59, 179, 174, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.er-unlock-body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.er-unlock-badge {\n  font-size: 11px;\n  font-weight: 700;\n  color: #3BB3AE;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.er-unlock-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.er-unlock-sub {\n  margin: 0;\n  font-size: 13px;\n  color: #a0aec0;\n  line-height: 1.45;\n}\n\n.er-unlock-btn {\n  white-space: nowrap;\n  padding: 12px 20px;\n  border-radius: 10px;\n  border: none;\n  background: #3BB3AE;\n  color: #0b1515;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.er-unlock-btn:hover {\n  background: #4be3cf;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 14px rgba(59, 179, 174, 0.4);\n}\n\n@media (max-width: 640px) {\n  .er-unlock-banner {\n    flex-direction: column;\n    text-align: center;\n    align-items: center;\n  }\n  .er-unlock-btn {\n    width: 100%;\n  }\n}\n\n/* ── Responsive ── */\n@media (max-width: 640px) {\n  .er-hero-title { font-size: 22px; }\n  .er-score-num  { font-size: 44px; }\n\n  /* Stack table to vertical cards on mobile */\n  .er-table-header { display: none; }\n\n  .er-table-row {\n    grid-template-columns: 1fr;\n    gap: 6px;\n  }\n\n  .er-td-q      { font-size: 11px; color: #64707d; }\n  .er-td-status { justify-content: flex-start; }\n\n  .er-td-question::before { content: 'Q: '; color: #64707d; font-weight: 700; }\n  .er-td-your::before     { content: 'Your: '; color: #64707d; font-weight: 700; }\n  .er-td-correct::before  { content: 'Correct: '; color: #64707d; font-weight: 700; }\n\n  .er-actions { flex-direction: column; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
